(function () {
  var SECTION_SELECTOR = '.oddit-search-drawer';

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function openDrawer(section) {
    if (!section) section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;
    section.style.display = '';
    void section.offsetWidth;

    var input = section.querySelector('[data-search-input]');

    if (isMobileViewport()) {
      // Defer to Boost PFS's full-screen mobile takeover. The drawer chrome
      // is hidden via CSS; focusing the Boost-attached input fires Boost's
      // input-focus handler which opens its own panel and manages the body
      // scroll lock. Skip our own animation and overflow lock.
      if (input) {
        setTimeout(function () { input.focus(); }, 0);
      }
      return;
    }

    section.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (input) {
      setTimeout(function () {
        input.focus();
        var v = input.value;
        if (v) input.setSelectionRange(v.length, v.length);
      }, 50);
    }
  }

  function closeDrawer(section) {
    if (!section) {
      section =
        document.querySelector(SECTION_SELECTOR + '.is-open') ||
        document.querySelector(SECTION_SELECTOR);
    }
    if (!section) return;

    var input = section.querySelector('[data-search-input]');
    if (input) input.blur();

    section.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!section.classList.contains('is-open')) {
        section.style.display = 'none';
      }
    }, 300);
  }

  function toggleDrawer(section) {
    if (!section) section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;
    if (section.classList.contains('is-open')) {
      closeDrawer(section);
    } else {
      openDrawer(section);
    }
  }

  function initSection(section) {
    if (!section || section.__odditSearchInitialized) return;
    section.__odditSearchInitialized = true;

    var controller = new AbortController();
    section.__odditSearchController = controller;

    var input = section.querySelector('[data-search-input]');
    var clearBtn = section.querySelector('[data-search-clear]');
    var closeBtn = section.querySelector('[data-search-close]');
    var overlay = section.querySelector('[data-search-overlay]');
    var form = section.querySelector('[data-search-form]');

    function syncClearVisibility() {
      if (!clearBtn || !input) return;
      clearBtn.hidden = input.value.trim().length === 0;
    }
    syncClearVisibility();

    if (input) {
      input.addEventListener('input', syncClearVisibility, {
        signal: controller.signal
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener(
        'click',
        function () {
          if (input) {
            input.value = '';
            // Fire input event so Boost clears its dropdown.
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.focus();
          }
          clearBtn.hidden = true;
        },
        { signal: controller.signal }
      );
    }

    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        function () {
          closeDrawer(section);
        },
        { signal: controller.signal }
      );
    }

    if (overlay) {
      overlay.addEventListener(
        'click',
        function () {
          closeDrawer(section);
        },
        { signal: controller.signal }
      );
    }

    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          if (!input || !input.value.trim()) {
            e.preventDefault();
          }
        },
        { signal: controller.signal }
      );
    }

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' && section.classList.contains('is-open')) {
          closeDrawer(section);
        }
      },
      { signal: controller.signal }
    );
  }

  function destroySection(section) {
    if (!section) return;
    if (section.__odditSearchController) {
      section.__odditSearchController.abort();
    }
    section.__odditSearchInitialized = false;
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target && e.target.querySelector
        ? e.target.querySelector(SECTION_SELECTOR)
        : null;
    if (section) initSection(section);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var section =
      e.target && e.target.querySelector
        ? e.target.querySelector(SECTION_SELECTOR)
        : null;
    if (section) destroySection(section);
  });

  // Public API — exposed as window.OdditSearchDrawer (PascalCase).
  window.OdditSearchDrawer = {
    open: function () {
      openDrawer();
    },
    close: function () {
      closeDrawer();
    },
    toggle: function () {
      toggleDrawer();
    }
  };
})();
